import { Pill } from '@mes-amis/galette-design-system';
import type { CaseNote } from '@/db/types/case_note';

/**
 * Where a note stands: waiting on this device, refused by Mon Ami, or (once
 * uploaded) pinned. Renders nothing for an ordinary uploaded note.
 */
export default function NoteStatusPill({ note }: { note: Pick<CaseNote, 'synced' | 'sync_error_message' | 'pinned'> }) {
  if (!note.synced && note.sync_error_message) {
    return <Pill text="Couldn't upload" color="red" size="sm" tooltip={note.sync_error_message} />;
  }
  if (!note.synced) return <Pill text="Waiting to upload" color="yellow" size="sm" />;
  if (note.pinned) return <Pill text="Pinned" color="gray" size="sm" />;
  return null;
}
